// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import CalendarSyncPreviewController from "./calendar_sync_preview_controller";
import DismissController from "./dismiss_controller";
import FieldWithErrorsController from "./field_with_errors_controller";
import FlashController from "./flash_controller";
import FormToggleController from "./form_toggle_controller";
import IntersectionObserverController from "./intersection_observer_controller";
import WorkingHoursController from "./working_hours_controller";

application.register("dismiss", DismissController);
application.register("field-with-errors", FieldWithErrorsController);
application.register("flash", FlashController);
application.register("form-toggle", FormToggleController);
application.register("intersection-observer", IntersectionObserverController);
application.register("working-hours", WorkingHoursController);
application.register("calendar-sync-preview", CalendarSyncPreviewController);
